export default {
  // Hero Section
  'hero.badge': 'Asian Alley Mini Mall — Riga, Latvia',
  'hero.title.line1': 'Asian Alley',
  'hero.title.line2': 'Kiosk Rental',
  'hero.description': 'Rent a kiosk to sell Asian products right in the heart of Riga — No experience needed, no language barrier, we provide full support!',
  'hero.price': 'Starting from',
  'hero.priceDay': '10 EUR/day',
  'hero.priceOr': 'or',
  'hero.priceMonth': '150 EUR/month',
  'hero.cta.register': 'Register Kiosk Now',
  'hero.cta.viewTypes': 'View Kiosk Types',
  'hero.stats.price': 'Price/day',
  'hero.stats.size': 'Size from',
  'hero.stats.support': 'Full Support',

  // Intro Section
  'intro.badge': 'Solution For You',
  'intro.title.line1': 'Are You Facing',
  'intro.title.line2': 'These Challenges?',
  'intro.problem1': 'Want to be your own boss but don\'t know where to start?',
  'intro.problem2': 'Not fluent in the local language?',
  'intro.problem3': 'Don\'t know what documents and paperwork are needed?',
  'intro.problem4': 'Don\'t have a stable business location yet?',
  'intro.solution.title': 'Asian Alley Mini Mall will support you!',
  'intro.solution.desc': 'We provide ready-to-use business space, support with paperwork, language, and operations — so you can focus on selling.',
  'intro.imageCaption': '✨ Asian Alley Mini Mall',
  'intro.imageSubCaption': 'Asian Products Shopping Center — Riga, Latvia',

  // Product Categories Section
  'categories.badge': 'Business Categories',
  'categories.title.line1': 'Suitable',
  'categories.title.line2': 'Products',
  'categories.subtitle': 'Asian Alley specializes in Asian goods and services — a booming niche market in Europe',
  'categories.swipeHint': 'Swipe to see more',
  'categories.cat1.title': 'Handicrafts',
  'categories.cat1.desc': 'Handmade items, paintings, souvenirs, unique traditional Asian products that attract tourists and locals.',
  'categories.cat1.tag': 'Popular',
  'categories.cat2.title': 'Clothing & Fabrics',
  'categories.cat2.desc': 'Asian fashion, traditional fabrics, ao dai, kimono, hanbok and distinctive fabrics from Vietnam, Japan, Korea, China.',
  'categories.cat2.tag': 'Best Seller',
  'categories.cat3.title': 'Jewelry & Accessories',
  'categories.cat3.desc': 'Bracelets, necklaces, earrings, hair pins, handbags and exquisite Asian fashion accessories at affordable prices.',
  'categories.cat3.tag': 'High Profit',
  'categories.cat4.title': 'Kitchen Utensils',
  'categories.cat4.desc': 'Clay pots, woks, tea sets, chopsticks, ceramic bowls and Asian cooking utensils loved by Europeans.',
  'categories.cat4.tag': 'High Demand',
  'categories.cat5.title': 'Services',
  'categories.cat5.desc': 'Haircuts, hair washing, manicures, massage, Asian-style skincare — services highly favored by Europeans.',
  'categories.cat5.tag': 'Service',

  // Kiosk Types Section
  'kiosk.badge': 'Rental Pricing',
  'kiosk.title': 'Kiosk',
  'kiosk.titleHighlight': 'Types',
  'kiosk.subtitle': 'Sizes from 1.7×2.5m to 2.5×2.5m — flexible according to your needs and budget',
  'kiosk.location': 'Location:',
  'kiosk.locationValue': 'Aspazijas Bulvaris 32, Riga, Latvia (Basement)',
  'kiosk.hours': 'Opening Hours:',
  'kiosk.hoursValue': '11:00 – 19:00, Monday – Sunday',
  'kiosk.swipeHint': 'Swipe to see more',
  'kiosk.mini.name': 'Mini Kiosk',
  'kiosk.mini.size': '1.7 × 2.5 m',
  'kiosk.mini.area': '4.25 m²',
  'kiosk.mini.daily': '10 EUR',
  'kiosk.mini.monthly': '150 EUR',
  'kiosk.mini.badge': 'Most Economical',
  'kiosk.standard.name': 'Standard Kiosk',
  'kiosk.standard.size': '2.5 × 2.5 m',
  'kiosk.standard.area': '6.25 m²',
  'kiosk.standard.daily': '25 EUR',
  'kiosk.standard.monthly': '250 EUR',
  'kiosk.standard.badge': 'Most Popular',
  'kiosk.office.name': 'Office Rental',
  'kiosk.office.size': 'From 20m²',
  'kiosk.office.area': '',
  'kiosk.office.daily': 'Contact',
  'kiosk.office.monthly': 'Contact',
  'kiosk.office.badge': 'Office',
  'kiosk.perDay': '/day',
  'kiosk.perMonth': '/month',
  'kiosk.or': 'or',
  'kiosk.contact': 'Quote on demand',
  'kiosk.popularBadge': '⭐ Most Chosen',
  'kiosk.features.mini': 'Suitable for accessories, jewelry, services.',
  'kiosk.features.standard': 'Suitable for clothing, handicrafts, kitchen utensils',
  'kiosk.features.office': 'Suitable for massage, online sales, consulting',
  'kiosk.feature1': 'Standard display counter',
  'kiosk.feature2': 'Basic electricity & water',
  'kiosk.feature3': 'Free WiFi',
  'kiosk.feature4': 'Facility fees included',
  'kiosk.feature5': 'Private space design',
  'kiosk.feature6': 'Dedicated electricity & water system',
  'kiosk.feature7': 'WiFi & support equipment',
  'kiosk.feature8': 'In-depth operational consulting',
  'kiosk.cta': 'Register This Kiosk',
  'kiosk.promo.badge': '🔥 Limited Offer',
  'kiosk.promo.period': 'Register from',
  'kiosk.promo.to': 'to',
  'kiosk.promo.desc': 'Get rental discounts in',
  'kiosk.promo.months': 'April, May, June',
  'kiosk.promo.discount1': '30% Off',
  'kiosk.promo.discount1Type': 'daily rate',
  'kiosk.promo.discount2': '20% Off',
  'kiosk.promo.discount2Type': 'monthly rate',
  'kiosk.note': '* Prices exclude 21% VAT. Prices may vary by location and time. Contact for the most accurate quote.',

  // Add-on Services Section
  'addon.badge': 'Add-on Services',
  'addon.title': 'Support',
  'addon.titleHighlight': 'Packages',
  'addon.subtitle': 'Additional service packages to help you operate professionally, legally and effectively in Latvia',
  'addon.flipHint': 'Tap card to view package details',
  'addon.flipViewFeatures': 'Tap to view',
  'addon.flipFeaturesCount': 'features',
  'addon.starter.name': 'STARTER',
  'addon.starter.subtitle': 'Startup Support',
  'addon.starter.price': '30',
  'addon.starter.badge': 'For Beginners',
  'addon.business.name': 'BUSINESS',
  'addon.business.subtitle': 'Professional Business',
  'addon.business.price': '60',
  'addon.business.badge': 'Most Popular',
  'addon.premium.name': 'PREMIUM',
  'addon.premium.subtitle': 'Comprehensive Business',
  'addon.premium.price': '100',
  'addon.premium.badge': 'Most Comprehensive',
  'addon.perMonth': 'EUR/month',
  'addon.popularBadge': '⭐ Most Chosen',
  'addon.feature.starter1': 'Self-employed registration support',
  'addon.feature.starter2': 'Bank account opening guidance (Revolut / Wise)',
  'addon.feature.starter3': 'Card payment setup guidance',
  'addon.feature.starter4': 'Basic tax consulting',
  'addon.feature.starter5': 'Suitable for beginners',
  'addon.feature.business1': 'All Starter package features',
  'addon.feature.business2': 'Monthly tax filing service',
  'addon.feature.business3': 'Tax authority liaison support',
  'addon.feature.business4': 'Product promotion on Asian Alley Mini Mall channel 3 times/month',
  'addon.feature.premium1': 'All Business package features',
  'addon.feature.premium2': 'Weekly product advertising',
  'addon.feature.premium3': 'Asian sourcing support',
  'addon.feature.premium4': 'SumUp card payment connection',
  'addon.feature.premium5': 'Product promotion on Asian Alley Mini Mall channel 10 times/month',
  'addon.feature.premium6': 'Sales staff recruitment posting',
  'addon.flipBack': 'Go Back',
  'addon.flipCta': 'Register This Plan',
  'addon.extras.title': 'Optional Additional Service Costs',
  'addon.extras.subtitle': 'Individual services on demand — separate quotes',
  'addon.extra1': 'Self-employed registration',
  'addon.extra2': 'One-time tax filing',
  'addon.extra3': 'Facebook advertising',
  'addon.extra4': 'Kiosk design',
  'addon.extra5': 'Kiosk signage',
  'addon.cta': 'Contact for Quote',
  'addon.note': '* Prices exclude 21% VAT. Contact for the most suitable package consultation.',

  // Support Section
  'support.badge': 'Comprehensive Support',
  'support.title': 'We Support',
  'support.titleHighlight': 'Everything',
  'support.subtitle': 'From paperwork, language to operations — Asian Alley accompanies you from day one',
  'support.doc.title': 'Document Support',
  'support.doc.desc': 'We guide and support all business registration procedures, operating licenses in Latvia according to legal regulations.',
  'support.lang.title': 'Language Support',
  'support.lang.desc': 'Vietnamese - Latvian - English translation team supports communication with customers, suppliers and authorities.',
  'support.space.title': 'Ready Space',
  'support.space.desc': 'Kiosks are basically equipped, full electricity and water, high-speed wifi — you just bring your goods and start selling.',
  'support.community.title': 'Business Community',
  'support.community.desc': 'Join the community of Asian kiosk owners in Riga — share experiences, support each other and grow together.',
  'support.marketing.title': 'Marketing & Promotion',
  'support.marketing.desc': 'Asian Alley organizes regular events and promotional programs attracting thousands of visitors each month.',
  'support.security.title': 'Safety & Security',
  'support.security.desc': '24/7 security camera system, professional security — your assets and goods are always absolutely protected.',

  // Gallery Section
  'gallery.badge': 'Real Photos',
  'gallery.title': 'Asian Alley',
  'gallery.titleHighlight': 'Space',
  'gallery.subtitle': 'Explore the vibrant, cozy business space with strong Asian identity',

  // CTA Banner Section
  'ctaBanner.title': 'Don\'t Miss the Best Spots!',
  'ctaBanner.subtitle': 'The number of kiosks at Asian Alley is limited. Register today for free consultation and choose the best location.',
  'ctaBanner.price': 'Starting from 10 EUR/day — Start your business in Europe now!',
  'ctaBanner.cta': 'Register Now — Free Consultation',
  'ctaBanner.phone': 'Call Now: +371 2572 6969',

  // Register Form Section
  'register.badge': 'Register Now',
  'register.title.line1': 'Reserve Kiosk',
  'register.title.line2': 'Best Location',
  'register.subtitle': 'Limited kiosks available — register early to choose the best location in Asian Alley. We will contact you for free consultation within 24 hours.',
  'register.info.location.title': 'Location',
  'register.info.location.value': 'Krisjana Barona Iela 96/98, Riga, Latvia',
  'register.info.hours.title': 'Operating Hours',
  'register.info.hours.value': 'Monday – Sunday: 10:00 – 20:00',
  'register.info.hotline.title': 'Hotline',
  'register.info.hotline.value': '+371 2572 6969',
  'register.info.email.title': 'Email',
  'register.info.email.value': 'contact@thedaeg.com',
  'register.promo.title': '🔥 Special Offer',
  'register.promo.desc': 'Register this month — free first week rental and completely free kiosk setup support!',
  'register.form.title': 'Fill Registration Information',
  'register.form.name': 'Full Name',
  'register.form.namePlaceholder': 'John Doe',
  'register.form.phone': 'Phone Number',
  'register.form.phonePlaceholder': '+371 or +84...',
  'register.form.email': 'Email',
  'register.form.emailPlaceholder': 'email@example.com',
  'register.form.kioskType': 'Interested Kiosk Type',
  'register.form.kioskTypePlaceholder': '-- Select kiosk type --',
  'register.form.kioskGroup.daily': '📅 Daily Rental',
  'register.form.kioskGroup.monthly': '📆 Monthly Rental',
  'register.form.kioskMiniDaily': 'Mini Kiosk (1.7×2.5m) — 10 EUR/day',
  'register.form.kioskStandardDaily': 'Standard Kiosk (2.5×2.5m) — 25 EUR/day',
  'register.form.kioskMiniMonthly': 'Mini Kiosk (1.7×2.5m) — 150 EUR/month',
  'register.form.kioskStandardMonthly': 'Standard Kiosk (2.5×2.5m) — 250 EUR/month',
  'register.form.kioskOfficeRent': 'Office Rental (from 20m²) — Contact for quote',
  'register.form.product': 'Expected Products / Services',
  'register.form.productPlaceholder': '-- Select category --',
  'register.form.productCraft': 'Handicrafts',
  'register.form.productClothing': 'Clothing & fabrics',
  'register.form.productJewelry': 'Jewelry & accessories',
  'register.form.productKitchen': 'Kitchen utensils',
  'register.form.productService': 'Services (haircut, nails...)',
  'register.form.productOther': 'Other',
  'register.form.addonTitle': 'Business Support Package (Optional)',
  'register.form.addonPlaceholder': '-- Select support package --',
  'register.form.addonNone': 'No support package needed',
  'register.form.addonStarter': 'STARTER — 30 EUR/month (Startup Support)',
  'register.form.addonBusiness': 'BUSINESS — 60 EUR/month (Professional Business)',
  'register.form.addonPremium': 'PREMIUM — 100 EUR/month (Comprehensive Business)',
  'register.form.extrasTitle': 'Optional Add-on Services',
  'register.form.extrasSubtitle': 'Select individual services you are interested in (multiple allowed)',
  'register.form.extraSelfEmployed': 'Self-employed registration',
  'register.form.extraTaxFiling': 'One-time tax filing',
  'register.form.extraFacebook': 'Facebook advertising',
  'register.form.extraKioskDesign': 'Kiosk design',
  'register.form.extraKioskSign': 'Kiosk signage',
  'register.form.message': 'Additional Notes',
  'register.form.messagePlaceholder': 'Your questions or special requests... (max 500 characters)',
  'register.form.messageLimit': '/500',
  'register.form.required': '*',
  'register.form.submit': '🏪 Register Kiosk Rental Now',
  'register.form.submitting': 'Submitting...',
  'register.success': '✅ Registration successful! We will contact you within 24 hours.',
  'register.error': '❌ An error occurred. Please try again or contact directly via hotline.',
  'register.note': 'Free consultation — No commitment — Response within 24 hours',

  // Page Meta
  'meta.title': 'Asian Alley — Rent Asian Products Kiosk in Riga Latvia | The Daeg International',
  'meta.description': 'Rent a kiosk to sell Asian products at Asian Alley Mini Mall – Riga, Latvia. Sizes 1.7×2.5m to 2.5×2.5m, prices from 20 EUR/day or 250 EUR/month. Full support with paperwork, language, and operations.',
  'meta.keywords': 'asian alley, kiosk rental riga latvia, asian products business europe, kiosk mini mall latvia, asian alley mini mall',
};